export default __webpack_public_path__ + "static/media/archive_image@3x.bb67ea04.jpg";